// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as AlertTriangleDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/alerts_feedback/alert-triangle.svg?react';
import { ReactComponent as AlertTriangleSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/alerts_feedback/alert-triangle.svg?react';
import { createIcons } from '../../Icon';
export const AlertTriangleIcon = /* @__PURE__ */ createIcons('AlertTriangle', {
    default: AlertTriangleDefault,
    solid: AlertTriangleSolid
});
AlertTriangleIcon.supportedTypes = [
    'default',
    'solid'
];
